import styled from 'styled-components';

export const StyledNodeImageRow = styled.div`
  background-color: ${({ theme }) => theme.colors.background.dark};
  margin-bottom: 0.8rem;
  border: 1px solid ${({ theme }) => theme.colors.background.grey};
  border-radius: 0.4rem;
  display: flex;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 80%;
  }
`;

export const StyledImageChangeContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledImageChangeGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1fr;
  gap: 0.8rem 2rem;
  padding: 0.8rem 1.6rem 1.6rem 1.6rem;
  margin-bottom: 0.8rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 2fr 2fr 2fr 7fr;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1.5fr 1fr 9fr 5fr;
  }
`;

export const StyledTask = styled.div`
  grid-area: 1 / 1 / 1 / 2;
  max-width: 7.5rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 1 / 1 / 1 / 2;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 1 / 1 / 1;
  }
`;

export const StyledQuestion = styled.div`
  grid-area: 1 / 2 / 1 / 3;
  max-width: 7.5rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 1 / 2 / 1 / 3;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 2 / 1 / 2;
    max-width: 5.3rem;
  }
`;

export const StyledMachineUrl = styled.div`
  grid-area: 2 / 1 / 2 / 4;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 1 / 3 / 1 / 5;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 3 / 1 / 3;
  }
`;

export const StyledLabel = styled.div`
  grid-area: 3 / 1 / 3 / 4;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 2 / 1 / 2 / 4;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 4 / 1 / 4;
  }
`;

export const StyledRemoveButton = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 4.6rem;

  & > button {
    border-color: ${({ theme }) => theme.colors.border.light};
    margin: auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 6.8rem;
  }
`;
